import { withPayloadType } from 'utils';
import { createAction } from '@reduxjs/toolkit';

export const listJobsStart = createAction(
  'LIST_JOBS::START',
  withPayloadType<{ organizationId: string }>(),
);
